export default {
    nettoMarkUps: [],
    nettoMarkUpsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters,
}

function setInitialFilters() {
    return {
        kind_id: 10
    }
}